module.exports = __webpack_public_path__ + "assets/img/32@3x.cae273bc.png";